import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Wifi = createReactComponent("Wifi", ["svg", defaultAttributes, [["path", {
  d: "M5 13a10 10 0 0114 0",
  key: "h8a88u"
}], ["path", {
  d: "M8.5 16.5a5 5 0 017 0",
  key: "gv8qp0"
}], ["path", {
  d: "M2 8.82a15 15 0 0120 0",
  key: "iokqm8"
}], ["line", {
  x1: "12",
  y1: "20",
  x2: "12.01",
  y2: "20",
  key: "5gs3sv"
}]]]);
export default Wifi;